module.exports = __webpack_public_path__ + "img/burger-menu.d2812f7a.svg";